import { Formik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { changeEmail } from "../../api/setting";
import Loader from "../../component/Loader";

function ChangeEmail() {
  const [loading, setLoading] = useState(false);
  return (
    <article className="col-lg-9">
      <div className="article-body store-bd-gy">
        <div className="form-style mt-5 addFormMw">
          <Formik
            initialValues={{
              currentPassword: "",
              email: "",
              toggle: false
            }}
            validationSchema={Yup.object({
              currentPassword: Yup.string().required("Required"),
              email: Yup.string().required("Required"),
            })}
            onSubmit={(values, { isSubmitting, resetForm }) => {
              setLoading(true);
              changeEmail({
                current_password: values.currentPassword,
                email: values.email,
              }).then((res) => {
                setLoading(false);

                if (res?.code === 1) {
                  resetForm();
                  toast.success(res?.message);
                } else {
                  toast.error(res?.message, {  autoClose: false,  closeButton: true});
                }
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFormikState,
            }) => (
              <form className="row" onSubmit={handleSubmit}>
                <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                  <h2 className="mdl-ttl">Change Email</h2>
                  <p>Please change your email address here</p>
                </div>
                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4 text-center">
                  <div className="input-container">
                    <input
                      type={values.toggle ? "text" : "password"}
                      className="form-control ps-4"
                      placeholder="Current Password"
                      name="currentPassword"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.currentPassword}
                    />
                    <img
                      src="assets/images/password.png"
                      className="input-img"
                      alt=""
                    />
                    <span
                      className={
                        values.toggle
                          ? "pass-hide field-icon "
                          : "pass-view field-icon "
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setFormikState((prevState) => {
                          return {
                            ...prevState,
                            values: {
                              ...prevState.values,
                              toggle: !prevState.values.toggle,
                            },
                          };
                        });
                      }}
                    ></span>
                  </div>
                  {errors.currentPassword && touched.currentPassword && (
                    <div className="text-red">{errors.currentPassword}</div>
                  )}
                </div>
                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4 text-center">
                  <div className="input-container">
                    <input
                      type="email"
                      className="form-control ps-4"
                      placeholder="Email address"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <img
                      src="assets/images/password.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {errors.email && touched.email && (
                    <div className="text-red">{errors.email}</div>
                  )}
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center">
                  <button
                    type="submit"
                    className="btn btn-save"
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Done"}
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </article>
  );
}

export default ChangeEmail;
